import ReportValue from "../../../components/generic/commonTableVal";
import React, { useEffect } from "react";
import "../../../stylesheets/components/generic/ReportsHeader/commonSummary.scss";
const CommonSummaryMob = (props) => {
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (React.createElement("div", { className: `summary_container-mob ${props.className}` },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "dflex-start summary-container-mob-toptile monochrome-light-gray-border" }, props.summaryData.map((ele, idx) => {
                return (React.createElement("div", { className: "col" },
                    React.createElement("div", { className: `${ele.externalClassName}`, key: idx },
                        React.createElement("p", { className: "summary_title" }, ele.title),
                        React.createElement("div", { className: "summary_values" }, ele.integer ? (React.createElement(React.Fragment, null,
                            React.createElement(ReportValue, { parentClass: "main_value", val: ele.value, stream: true, onlyval: false }),
                            ele.percentageValue !== null &&
                                ele.percentageValue !== undefined && (React.createElement(ReportValue, { parentClass: "percentage_value", val: ele.percentageValue, stream: true, onlyval: false, percentage: true })))) : (React.createElement(React.Fragment, null,
                            React.createElement(ReportValue, { val: ele.value, stream: false, onlyval: true })))),
                        ele.text && React.createElement("p", { className: "summary_text" }, ele.text))));
            })),
            React.createElement("div", { className: `png-container-wrapper ${scrollPosition > 50 && (props === null || props === void 0 ? void 0 : props.dock)
                    ? "png-container-dock docked_box_shadow_mob"
                    : ""}` }, props.TotalsummaryData.map((ele, idx) => {
                return (React.createElement("div", { className: `${ele.externalClassName}`, key: idx },
                    React.createElement("p", { className: "summary_title" }, ele.title),
                    React.createElement("div", { className: "summary_values" }, ele.integer ? (React.createElement(React.Fragment, null,
                        React.createElement(ReportValue, { parentClass: "main_value", val: ele.value, stream: true, onlyval: false }),
                        ele.percentageValue !== null &&
                            ele.percentageValue !== undefined && (React.createElement(ReportValue, { parentClass: "percentage_value", val: ele.percentageValue, stream: true, onlyval: false, percentage: true })))) : (React.createElement(React.Fragment, null,
                        React.createElement(ReportValue, { val: ele.value, stream: false, onlyval: true })))),
                    ele.text && React.createElement("p", { className: "summary_text" }, ele.text)));
            })))));
};
export default CommonSummaryMob;
